export default {
  isLockedRenderLimit: true,
  isLocked: true,
  appVersion: "beta",
  currRoute: null,
  isThemeDark: false,
  currLocale: "en",
  supportedVersion: null,
  isSupportedVersionFeatched: false,
  alert: { type: null, message: null, icon: "info", translate: false },
  formErrors: {
    email: "",
    password: "",
    username: "",
    first_name: "",
    last_name: "",
  },
};
